import React from 'react';
import intl from "react-intl-universal";
import {observer} from "mobx-react-lite";

import {useAppState} from "@stores/AppStateContext";
import type {ViewType, WorkspaceModelType} from "@stores/WorkspaceStore";

import {ContextMenu} from '../../../components/ContextMenu/ContextMenu';
import {changeView} from '../../../../actions/ui/changeView';

export interface TreeViewOptionsProps {
    handleClose: () => void;
    isDark?: boolean;
    workspace: WorkspaceModelType;
}

export const TreeViewOptions = observer(({ handleClose, isDark, workspace }: TreeViewOptionsProps) => {
    const appState = useAppState();
    const rootStore = appState.rootStore;

    const viewOptions = [
        {
            value: 'recent' as ViewType,
            label: intl.get('workspace-row-context.recent').d('Recent'),
        },
        {
            value: 'active' as ViewType,
            label: intl.get('workspace-row-context.active').d('Active'),
        },
        {
            value: 'archive' as ViewType,
            label: intl.get('workspace-row-context.archive').d('Archive'),
        },
        {
            value: 'trash' as ViewType,
            label: intl.get('workspace-row-context.trash').d('Trash'),
        },
    ];

    return (
        <ContextMenu
            isDark={isDark}
            handleClose={handleClose}
            items={viewOptions.map(option => ({
                text: option.label,
                onClick: () => {
                    changeView(rootStore, option.value, workspace);
                    appState.setContextMenu(null);
                },
            }))}
        />
    );
});
